import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=e7e0f546&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"
import style0 from "./PackageCard.vue?vue&type=style&index=0&id=e7e0f546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e0f546",
  null
  
)

export default component.exports